import React, { useEffect, useState } from 'react';

const Footer = () => {
  return (
    <>
      <footer className='main-footer'>
        <div className='main-footer-opacity'>
          <div className='auto-container'>
            <div className='widgets-section'>
              <div className='row clearfix'>
                <div className='column col-lg-4 col-md-6 col-sm-12'>
                  <div className='footer-widget logo-widget'>
                    <div className='widget-content'>
                      <div className='footer-logo'>
                        <a href=''>
                          <img
                            className='lazy-image'
                            src='../assets/images/logo.png'
                            data-src='../assets/images/logo.png'
                            alt=''
                          />
                        </a>
                      </div>
                      <div className='text'>
                        Sadqa-E-Jariya Welfare Foundation has been established
                        with the goal to support the orphans (yateems) and
                        widows (bewas) of our community.
                      </div>
                      <ul className='social-links clearfix'>
                        <li>
                          <a
                            href='https://www.facebook.com/sejwf'
                            target={'_blank'}
                          >
                            <span className='fab fa-facebook-f'></span>
                          </a>
                        </li>
                        {/* <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                        <li><a href="#"><span className="fab fa-vimeo-v"></span></a></li>
                        <li><a href="#"><span className="fab fa-instagram"></span></a></li> */}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className='column col-lg-4 col-md-6 col-sm-12'>
                  <div className='footer-widget links-widget'>
                    <div className='widget-content'>
                      <h3>Our Programs</h3>
                      <ul>
                        <li>
                          <a href='/free-grocery-for-widows-and-senior-citizen'>
                            Free Grocery for Widows and Senior Citizen
                          </a>
                        </li>
                        <li>
                          <a href='/apna-rozgar'>
                            Apna Rozgar (Small Business Setups)
                          </a>
                        </li>
                        <li>
                          <a href='/medical-support'>Free Medical Support</a>
                        </li>
                        <li>
                          <a href='/basic-schools'>
                            Free Education for Child (Basic Schools)
                          </a>
                        </li>
                        <li>
                          <a href='/water-hand-pumps'>
                            Clean Water Program (Water Hand Pumps)
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className='column col-lg-4 col-md-6 col-sm-12'>
                  <div className='footer-widget info-widget'>
                    <div className='widget-content'>
                      <h3>Contacts</h3>
                      <ul className='contact-info'>
                        <li>
                          <i className='flaticon-location'></i> office #3 plot
                          59c street 12 phase 2 extion.
                        </li>
                        <li>
                          <i className='flaticon-mail'></i>{' '}
                          contact@sadqajariya.com
                        </li>
                        <li>
                          <i className='flaticon-phone-call'></i> 03-11 -11
                          (SADQA) 72372
                        </li>
                        <li>
                          <i className='flaticon-phone-call'></i> (850)
                          42-(SADQA) 72372
                        </li>
                        {/* <li><i className="flaticon-phone-call"></i> +92 0213 5803423</li> */}
                      </ul>
                    </div>
                  </div>
                </div>

                {/* <!--Column--> */}
                {/* <div className="column col-lg-3 col-md-6 col-sm-12">
                <div className="footer-widget news-widget">
                  <div className="widget-content">
                    <h3>Top News</h3>
                    <div className="news-post">
                      <div className="post-thumb"><a href="#"><img className="lazy-image" src="images/resource/image-spacer-for-validation.png" data-src="images/resource/post-thumb-1.jpg" alt="" /></a></div>
                      <h5><a href="#">School for African Childrens</a></h5>
                      <div className="date">July 25, 2019</div>
                    </div>
                    <div className="news-post">
                      <div className="post-thumb"><a href="#"><img className="lazy-image" src="images/resource/image-spacer-for-validation.png" data-src="images/resource/post-thumb-2.jpg" alt="" /></a></div>
                      <h5><a href="#">School for African Childrens</a></h5>
                      <div className="date">July 25, 2019</div>
                    </div>
                  </div>
                </div>
              </div> */}
              </div>
              <div className='nav-box clearfix'>
                <div className='inner clearfix'>
                  <ul className='footer-nav clearfix'>
                    <li>
                      <a href='/'>Home</a>
                    </li>
                    <li>
                      <a href='/about'>About</a>
                    </li>
                    <li>
                      <a href='/videos'>Videos</a>
                    </li>
                    {/* <li><a href="#">Events</a></li>
                    <li><a href="#">Blog</a></li>
                    <li><a href="#">Contact</a></li> */}
                  </ul>
                  <div className='donate-link'>
                    <a href='/get-involved' className='theme-btn btn-style-one'>
                      <span className='btn-title'>Donate Now</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='footer-bottom'>
            <div className='auto-container'>
              {/* &copy; */}
              <div className='clearfix'>
                <div className='copyright'>
                  © 2024 Sadqa-E-Jariya Welfare Foundation (sadqajariya.com).
                  All right reserved.
                </div>
                {/* <ul className="bottom-links">
                  <li><a href="/">Terms of Service</a></li>
                  <li><a href="/">Privacy Policy</a></li>
                </ul> */}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
